import { getCompetitionMenuPageUrl } from "../../../../utils/urls"
import { LocalizedCompetition } from "types/competition"
import { Col, Row } from "react-bootstrap"
import React from "react"
import { CompetitionDetails } from "@components/Competition/CompetitionDetails/CompetitionDetails"
import { TabsCompetition } from "@components/UI/TabsCompetition"
import CompetitionMenu from "../CompetitionMenu/CompetitionMenu"
import style from "./style.module.scss"

const buttons = [
  {
    key: "generale",
    label: "Generale",
    alwaysShow: true,
  },
  {
    key: "calendario-risultati",
    label: "Calendario e Risultati",
    alwaysShow: true,
  },
  {
    key: "classifica",
    label: "Classifica",
    alwaysShow: false,
  },
  {
    key: "statistiche-giocatori",
    label: "Statistiche Giocatori",
    alwaysShow: false,
  },
  {
    key: "statistiche-squadre",
    label: "Statistiche Squadre",
    alwaysShow: false,
  },
  {
    key: "squadre",
    label: "Squadre",
    alwaysShow: true,
  },
  {
    key: "albo-oro",
    label: "Albo d'oro",
    alwaysShow: true,
  },
]

export function CompetitionPageHeader({
  selected,
  competitionCalciocomSlug,
  competition,
  showAll = true,
}: {
  selected: string
  competitionCalciocomSlug: string
  competition: LocalizedCompetition & { teamNumber: number }
  showCompetitionInfo?: boolean
  showAll?: boolean
}) {
  return (
    <div className={style.competitionHeaderContainer}>
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <CompetitionDetails competition={competition} />
        </Col>
      </Row>
      <Row>
        <CompetitionMenu competitionCalciocomSlug={competitionCalciocomSlug} selectedId={selected} />
      </Row>
      <Row>
        <TabsCompetition
          className="competition-tabs-cc competition-new-tabs"
          competitionCalciocomSlug={competitionCalciocomSlug}
          options={buttons
            .filter((button) => showAll || button.alwaysShow)
            .map((button) => ({ value: button.key, label: button.label }))}
          selectedId={selected}
          onChange={(selectedKey) => {
            window.location.href = getCompetitionMenuPageUrl(competitionCalciocomSlug, selectedKey as string)
          }}
        />
      </Row>
    </div>
  )
}
